import { Component, OnInit, ViewChild, SecurityContext } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-document-modal',
  templateUrl: './document-modal.component.html',
  styleUrls: ['./document-modal.component.css']
})
export class DocumentModalComponent implements OnInit {

  @ViewChild('documentModal', { static: false }) documentModal: ModalDirective;

  readonly SCREEN_ID = 'O81';

  public message: SafeHtml;

  public documentName: string;

  public url: string;

  public documentUrl: SafeHtml;

  public observer: Observer<boolean>;

  public observable: Observable<boolean>;

  constructor(private sanitizer: DomSanitizer) {
    this.observable = new Observable(observer => { this.observer = observer; });
    this.documentUrl = sanitizer.bypassSecurityTrustResourceUrl('');
  }

  ngOnInit() {
  }

  // AduMEの規約も同じメソッドで呼び出したいため、引数は規約名とURLとしている
  showModal(documentName: string, documentUrl: string): Observable<boolean> {
    // DBから持ってきたURLを一応無害化
    // SecurityContext.ResourceURLだとエラーが出てしまうため、SecurityContext.URLとしている
    const sanitizedDocumentUrl = this.sanitizer.sanitize(SecurityContext.URL, documentUrl);
    this.documentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(sanitizedDocumentUrl);

    // 規約名はAngularの補完構文({{documentName}})で表示するため安全
    this.documentName = documentName;

    this.documentModal.show();

    return this.observable;
  }

  hideModal(): void {
    this.documentModal.hide();
    this.observer.next(true);
  }

}
